import {Component, ElementRef, HostListener, Inject, OnInit, Renderer2} from '@angular/core';
import {DOCUMENT, Location} from '@angular/common';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {AppComponent} from '../../app.component';
import {djangourl} from '../../../assets/urls';
import {HttpClient} from '@angular/common/http';

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = 0;

@Component({
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.scss']
})
export class LandingLayoutComponent implements OnInit {
  private _router: Subscription;
  notifications: any;
  notificationsUrl = djangourl + 'api/notifications/';

  constructor(private http: HttpClient,
              private appcom: AppComponent,
              private router: Router,
              private renderer: Renderer2,
              @Inject(DOCUMENT) private document: any,
              private element: ElementRef,
              public location: Location) {
  }

  @HostListener('window:scroll', ['$event'])
  hasScrolled() {

    var st = window.pageYOffset;
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) {
      return;
    }

    var navbar = document.getElementsByTagName('nav')[0];

    // If they scrolled down and are past the navbar, add class .headroom--unpinned.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      if (navbar.classList.contains('headroom--pinned')) {
        navbar.classList.remove('headroom--pinned');
        navbar.classList.add('headroom--unpinned');
      }
      // $('.navbar.headroom--pinned').removeClass('headroom--pinned').addClass('headroom--unpinned');
    } else {
      // Scroll Up
      //  $(window).height()
      if (st + window.innerHeight < document.body.scrollHeight) {
        // $('.navbar.headroom--unpinned').removeClass('headroom--unpinned').addClass('headroom--pinned');
        if (navbar.classList.contains('headroom--unpinned')) {
          navbar.classList.remove('headroom--unpinned');
          navbar.classList.add('headroom--pinned');
        }
      }
    }

    lastScrollTop = st;
  }


  ngOnInit(): void {

    this.http.get(this.notificationsUrl + 'all/').subscribe(data => {
      this.notifications = data;
    });
  }

  removeNotification(index: any) {
    this.notifications.splice(index, 1);
  }
}
